import { ArrowRight } from 'lucide-react'

interface TechnologyMigrationPathProps {
  from: string[]
  to: string[]
}

export function TechnologyMigrationPath({ from, to }: TechnologyMigrationPathProps) {
  const fromText = from.length > 0 ? from.join(', ') : '—'
  const toText = to.length > 0 ? to.join(', ') : '—'
  const showArrow = to.length > 0

  return (
    <div
      className="flex items-center gap-2 text-sm"
      data-testid="technology-migration-path"
    >
      <span>{fromText}</span>
      {showArrow && (
        <>
          <ArrowRight className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
          <span>{toText}</span>
        </>
      )}
    </div>
  )
}
